var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86901 0.230469C3.20212 0.230469 0.229492 3.22362 0.229492 6.91553C0.229492 10.6074 3.20234 13.6006 6.86901 13.6006C10.5357 13.6006 13.5085 10.6077 13.5085 6.91553C13.5085 3.2234 10.536 0.230469 6.86901 0.230469ZM17.472 0.622071C15.6385 0.622071 14.1524 3.44043 14.1524 6.91564C14.1524 10.3908 15.6387 13.2094 17.4722 13.2094C19.3057 13.2094 20.792 10.391 20.792 6.91564H20.7918C20.7918 3.43943 19.3057 0.622071 17.4721 0.622071H17.472ZM22.6036 1.2776C21.9589 1.2776 21.4363 3.80201 21.4363 6.91564C21.4363 10.0293 21.9586 12.5537 22.6036 12.5537C23.2486 12.5537 23.7713 10.0286 23.7713 6.91553C23.7713 3.80179 23.2484 1.2776 22.6037 1.2776H22.6036Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/medium-icon.04643ede9fc4c373db9898243951485e.svg";
export { ForwardRef as ReactComponent };